import { FeatureFlag } from 'src/models/platform/_types';
import { isTrainer } from 'src/models/user/utils';
import { hasFeatureFlag } from 'src/shared/usePermissionCheck';

import type { Session } from 'src/models/session/_types';
import type { User } from 'src/models/user/_types';

/**
 * Per-user resolution of whether the new "Dreamcoat" navigation/chrome applies.
 * Mirrors the server logic in `PlatformTabsSerializerDefaults#dreamcoat_active?`
 * so the React chrome and the serialized tabs always agree:
 *
 * - `Dreamcoat Frame` forces the new nav on for the whole gym (no toggle).
 * - `Dreamcoat Opt In` only gates the per-staff-user toggle; it takes effect for
 *   a staff member who has individually opted in (`user.dreamcoatNav`).
 * - Clients always stay on the old nav.
 *
 * Lives in its own module rather than in `usePermissionCheck` so that importing
 * `hasFeatureFlag` here does not close an import cycle. Do not make
 * `hasFeatureFlag` depend on this module in turn.
 */
export const isDreamcoatActive = (
  session?: Session | null,
  user?: User | null
): boolean => {
  if (!session) {
    return false;
  }

  if (hasFeatureFlag(session, FeatureFlag.DreamcoatFrame)) {
    return true;
  }

  return (
    hasFeatureFlag(session, FeatureFlag.DreamcoatOptIn) &&
    isTrainer(user ?? undefined) &&
    !!user?.dreamcoatNav
  );
};
